var _path, _path2;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgCloseIcon = function SvgCloseIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.46262 7.99996L13.697 12.234C14.101 12.6379 14.101 13.2929 13.697 13.6969C13.293 14.1009 12.6379 14.1009 12.2339 13.6969L7.26797 8.73144C6.86395 8.32745 6.86395 7.67246 7.26797 7.26847L12.2339 2.30299C12.6379 1.899 13.293 1.899 13.697 2.30299C14.101 2.70698 14.101 3.36197 13.697 3.76596L9.46262 7.99996Z",
    fill: "#9595B1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.53738 8.00004L2.30302 12.234C1.899 12.638 1.899 13.293 2.30302 13.697C2.70704 14.101 3.36209 14.101 3.76611 13.697L8.73203 8.73153C9.13605 8.32754 9.13605 7.67254 8.73203 7.26856L3.76611 2.30308C3.36209 1.89909 2.70704 1.89909 2.30302 2.30308C1.89899 2.70706 1.89899 3.36206 2.30302 3.76604L6.53738 8.00004Z",
    fill: "#9595B1"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCloseIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/closeIcon.4bd9976c.svg";
export { ForwardRef as ReactComponent };